<template>
  <!--html do computador-->
  <div class="hidden-sm hidden-xs">

    <nav class="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light site-navbar-target">
      <div class="container">
        <router-link to="/" class="navbar-brand"><img :src="$imagens + 'induscapas-logo.png'"></router-link>
        <button class="navbar-toggler js-fh5co-nav-toggle fh5co-nav-toggle" type="button">
          <span class="oi oi-menu"></span> Menu
        </button>

        <div class="collapse navbar-collapse">
          <ul class="navbar-nav nav ml-auto">
            <li class="nav-item"><router-link to="/" class="nav-link"><span>Home</span></router-link></li>
            <li class="nav-item"><router-link to="/quemsomos" class="nav-link"><span>Quem Somos</span></router-link>
            </li>
            <li class="nav-item"><router-link to="/produtos" class="nav-link"><span>Produtos</span></router-link></li>
            <li class="nav-item"><router-link to="/clientes" class="nav-link"><span>Clientes</span></router-link></li>
            <li class="nav-item"><router-link to="/contato" class="nav-link"><span>Contato</span></router-link></li>
            <li class="nav-item"><router-link to="/carrinho" class="nav-link"><span>Carrinho</span></router-link></li>
          </ul>
          <div>
            <router-link to="/carrinho">
              <img :src="$imagens + 'carrinho.svg'">
               <div v-if="variavelHeader2 != ''" class="qty">{{ variavelHeader2 }}</div>
             </router-link>
        </div>
        </div>
      </div>
    </nav>

  </div><!--END html do computador-->

  <!--html do celular-->
  <div class="container hidden-lg hidden-md" style="position:absolute; z-index: 3;">
    <div class="row celular-alinhado">
      <div class="col-3" style="margin-top: 5px;">
        <v-menu :close-on-content-click="true">
          <template v-slot:activator="{ props }">
            <v-btn icon="mdi-dots-vertical" v-bind="props"></v-btn>
          </template>
          <v-list class="celular-topo">
            <v-list-item><router-link to="/"><v-list-item-title class=" menu"
                  style="color: #000000;">Home</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/quemsomos"><v-list-item-title class=" menu" style="color: #000000;">Quem
                  Somos</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/produtos"><v-list-item-title class=" menu"
                  style="color: #000000;">Produtos</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/clientes"><v-list-item-title class=" menu"
                  style="color: #000000;">Clientes</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/contato"><v-list-item-title class=" menu"
                  style="color: #000000;">Contato</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/carrinho"><v-list-item-title class=" menu"
                  style="color: #000000;">Carrinho</v-list-item-title></router-link></v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div class="col-9">
        <router-link to="/"><img src="/images/induscapas-logo.png" alt="" style="width: 100%;"></router-link>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'PageHeader',
  components: {

  },
  data: () => ({
    topoMenu: [],
    showModernizacaoMenu: false,
    return: {
      isMenuOpen: false
    }
  }),
  methods: {
      calculatotal() {
          let dadosArmazenados = localStorage.getItem(this.$DadosCompra);
          if (dadosArmazenados) {
              dadosArmazenados = JSON.parse(dadosArmazenados);
              this.$store.commit('updateVariavelHeader2', dadosArmazenados.produtos.length);
          }
          
        },
    toggleModernizacaoMenu() {
      this.showModernizacaoMenu = !this.showModernizacaoMenu;
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    }
  },
  created() {
     this.calculatotal();
    //texto e logo avance 
    axios.get('/Process/InsInstitucional/institucional/9/cabecalho/0/x')
      .then(response => {
        this.topoMenu = response.data;
        //console.log('topo menu')
        //console.log(this.topoMenu)
      })
      .catch(error => {
        console.error(error);
      });
  },
  computed: {
      ...mapState(['variavelHeader1', 'variavelHeader2'])
  },
};
</script>

<style scoped>
.menuTamanho {
  size: 16px;
  text-align: left;
  line-height: 1.5;
}
</style>
